/**
 * @fileoverview GET handler for the "/alloys/gemini/agentic/:app_group_id/oauth/projects" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { alloysGeminiAgenticAppGroupIdOauthProjects } from "./constants";
import type { GetAlloysGeminiAgenticOauthProjectsResult } from "./types";
import { isGetAlloysGeminiAgenticOauthProjectsResult } from "./validators";

export const getAlloysGeminiAgenticAppGroupIdOauthProjects = reactQueryFetcherAdapter(
  alloysGeminiAgenticAppGroupIdOauthProjects,
  (signal: AbortSignal, appGroupId: string): Promise<GetAlloysGeminiAgenticOauthProjectsResult> => {
    return fetch(
      `/alloys/gemini/agentic/${appGroupId}/oauth/projects`,
      "GET",
      {},
      { signal },
      { propagateFetchRequestError: false }
    );
  },
  isGetAlloysGeminiAgenticOauthProjectsResult
);
